import _get from 'lodash/get';

interface CompaniesCustomerListItem {
  id: string | number;
  srno: number;
  shortName: string;
  customer: string;
  status: string;
  actions: string;
}

interface CompaniesCustomerApiParser {
  CompaniesCustomerListParser: (_res: any) => CompaniesCustomerListItem[];
}

const companiesCustomerApiParser: CompaniesCustomerApiParser = {
  CompaniesCustomerListParser: (_res: unknown): CompaniesCustomerListItem[] => {
    const content = _get(_res, 'data.content', []) as any[];

    if (Array.isArray(content) && content.length > 0) {
      return content.map((itm, idx) => ({
        id: _get(itm, 'companyId', 0),
        srno: Number(_get(itm, 'companyId', idx + 1)),
        shortName: _get(itm, 'shortName', ''),
        customer: _get(itm, 'companyName', ''),
        status: _get(itm, 'active', false) ? 'Active' : 'Inactive',
        actions: 'Edit',
      }));
    }

    return [];
  },
};

export default companiesCustomerApiParser;

// --------------- Companies Customer-specific types and data ---------------

export interface CompaniesCustomerItem {
  id: number;
  shortName: string;
  customer: string;
  status: string;
}

export interface CompaniesCustomerData {
  companiesCustomers: CompaniesCustomerItem[];
  companies: { value: string; label: string }[];
  statusOptions: { value: string; label: string }[];
}
